import { useTranslation } from "react-i18next"

import { useUpdatesPerSecond } from "./stats.state"

export const Updates = () => {
  const { t } = useTranslation()
  const count = useUpdatesPerSecond()

  return (
    <p className="mr-2 text-sm-regular">
      {t("stats.uiUpdates", { count })}
      <span>{t("stats.secondsAbbr")}</span>
    </p>
  )
}
